<template>
    <div class="staffBox">
        <avue-crud :data="data" :option="option" :page.sync="page" @current-change="changePage">
            <template slot-scope="scope" slot="menuLeft">
                <el-button class="customize" @click="dialogVisible=true">添加员工</el-button>
            </template>
            <template slot="menu" slot-scope="scope" >
                <el-button class="customize" @click="editBtn(scope.row)" v-if="scope.row.user_type !=2">编辑</el-button>
            </template>
            <template slot="user_type" slot-scope="scope" >
                <span v-if="scope.row.user_type==2">企业管理员</span>
                <span v-if="scope.row.user_type==3">企业员工</span>
            </template>
<!--            企业员工状态-->
            <template slot="status" slot-scope="scope" >
                <span v-if="scope.row.status==1">在职</span>
                <span v-else>离职</span>
            </template>
        </avue-crud>
<!--        添加员工-->
        <el-dialog
                title="添加员工"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                width="30%">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="ruleForm.name" style="width: 85%"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="ruleForm.mobile" style="width: 85%"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="captcha">
                    <div style="display: flex;width: 85%">
                        <el-input  v-model="ruleForm.captcha" placeholder="请输入验证号" maxlength="6" ></el-input>
                        <el-button @click="getCodes" :disabled="disadles">{{ msgText }}</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="员工状态" prop="status">
                    <el-radio v-model="ruleForm.status" label="1">在职</el-radio>
                    <el-radio v-model="ruleForm.status" label="0">离职</el-radio>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAddBtn">确 定</el-button>
            </span>
        </el-dialog>
<!--        编辑员工状态-->
        <el-dialog
                title="编辑员工状态"
                :visible.sync="employeeStatus"
                :close-on-click-modal="false"
                width="30%">
            <el-form ref="form" :model="employee" label-width="80px">
                <el-form-item label="姓名">
                    <el-input v-model="employee.name" disabled style="width: 85%"></el-input>
                </el-form-item>
                <el-form-item label="员工状态" prop="status">
                    <el-radio v-model="employee.status" :label="1">在职</el-radio>
                    <el-radio v-model="employee.status" :label="0">离职</el-radio>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelBtn">取 消</el-button>
                <el-button type="primary" @click="editorialStaff">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { addStaff, editStatus, staffList, verificationCode } from '../../../api/personal';

    export default {
        name: 'employeeList',
        inject: ['reload'], // 引入方法
        data() {
            return {
                page:{
                    currentPage: 1,
                    total: 10,  //总数
                    pageSize: 10 //每页多少
                },
                data: [],
                dialogVisible:false,  //添加员工
                employeeStatus:false,  //编辑员工状态
                employee:'',         //员工id
                ruleForm:{
                    name:'',          //姓名
                    mobile:'',        //手机号
                    captcha:'',  //验证码
                    status:'1',      //员工状态 1在职 0离职
                },
                rules:{
                    name:[
                        {required: true, message: '请输入员工姓名', trigger: 'blur' }
                    ],
                    mobile:[
                        {required: true, message: '请输入员工手机号', trigger: 'blur' }
                    ],
                    captcha:[
                        {required: true, message: '请输入验证码', trigger: 'blur' }
                    ]
                },
                disadles: false,
                count: 60,
                msgText: "获取验证码",
                option:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'员工姓名',
                            prop:'name'
                        }, {
                            label:'员工手机号',
                            prop:'mobile'
                        }, {
                            label:'员工身份',
                            prop:'user_type'
                        }, {
                            label:'企业员工状态',
                            prop:'status'
                        },
                    ]
                },
            };
        },
        methods:{
            //分页
            changePage(num){
                staffList(10,num).then(res=>{
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                    }
                })
            },
            //获取验证码
            getCodes() {
                verificationCode(this.ruleForm.mobile).then(res=>{
                    if(res.code==200){
                        this.$message.success(res.msg);
                        let times = 60;
                        let setInter = setInterval(() => {
                            times--;
                            if (times <= 0) {
                                this.msgText = "获取验证码";
                                this.disadles = false;
                                clearInterval(setInter);
                            } else {
                                this.msgText = "重新获取(" + times + ")";
                                this.disadles = true;
                            }
                        }, 1000);
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            //确认添加员工
            confirmAddBtn(){
                addStaff(this.ruleForm.name,this.ruleForm.mobile,this.ruleForm.captcha,this.ruleForm.status).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                        this.dialogVisible=false
                        this.reload()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            },
            cancelBtn(){
                this.employeeStatus = false
                this.reload()
            },
            //编辑按钮
            editBtn(row){
                this.employee=row
                this.employeeStatus=true
            },
            //编辑员工状态
            editorialStaff(){
                editStatus(this.employee.id,this.employee.name,this.employee.status).then(res=>{
                    if (res.code=200){
                        this.$message.success(res.msg)
                        this.employeeStatus=false
                        this.reload()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        created() {
            staffList(10,1).then(res=>{
                if (res.code==200){
                    this.data=res.data.list
                    this.page.total=res.data.count
                    this.page.currentPage=1
                }
            })
        }
    };
</script>

<style scoped>
    .staffBox{
        padding: 20px;
        margin: 10px;
        background-color: #fff;
        border-radius: 5px;
    }
    .customize{
        background-color: #3e62f6;
        color: #fff;
    }
</style>
